module.exports = __webpack_public_path__ + "static/media/poweredByIota.bca9b626.svg";